import { C2dCoreQuadList } from "./C2dCoreQuadList";
import { C2dCoreQuadOperation } from "./C2dCoreQuadOperation";
import { C2dCoreRenderExecutor } from "./C2dCoreRenderExecutor";
import { C2dDefaultShader } from "./shaders/C2dDefaultShader";
import { C2dShader } from "./C2dShader";
import { Renderer } from "../Renderer";
import { C2dTextureTintManager } from "./C2dTextureTintManager";
import { C2dCoreRenderState } from "./C2dCoreRenderState";
export class C2dRenderer extends Renderer {
    constructor(stage) {
        super(stage);
        this.tintManager = new C2dTextureTintManager(this.stage);
        this.setupCanvasAsRenderTexture(stage.canvas);
    }
    destroy() {
        this.tintManager.destroy();
    }
    _createDefaultShader(context) {
        return new C2dDefaultShader(context);
    }
    _getShaderBaseType() {
        return C2dShader;
    }
    _getShaderAlternative(shaderType) {
        return shaderType.getC2d();
    }
    createCoreQuadList() {
        return new C2dCoreQuadList();
    }
    createCoreQuadOperation(context, shader, shaderOwner, renderTextureInfo, scissor, index) {
        return new C2dCoreQuadOperation(context, shader, shaderOwner, renderTextureInfo, scissor, index);
    }
    createCoreRenderExecutor(context) {
        return new C2dCoreRenderExecutor(context);
    }
    createCoreRenderState(context) {
        return new C2dCoreRenderState(context);
    }
    createRenderTexture(w, h, pw, ph) {
        const canvas = document.createElement("canvas");
        canvas.width = pw;
        canvas.height = ph;
        this.setupCanvasAsRenderTexture(canvas);
        return canvas;
    }
    freeRenderTexture(renderTexture) {
        this.tintManager.delete(renderTexture);
    }
    gc(aggressive) {
        this.tintManager.gc(aggressive);
    }
    uploadTextureSource(textureSource, options) {
        // In case of Context2d, we usually do not need to upload.
        // Only in case of ArrayBuffer
        // For canvas, we do not need to upload.
        if (options.source instanceof Uint8ClampedArray) {
            // Convert RGBA buffer to canvas.
            const canvas = document.createElement("canvas");
            canvas.width = options.width;
            canvas.height = options.height;
            const imageData = new ImageData(options.source, options.width, options.height);
            canvas.getContext("2d").putImageData(imageData, 0, 0);
            return canvas;
        }
        return options.source;
    }
    freeTextureSource(textureSource) {
        this.tintManager.delete(textureSource.nativeTexture);
    }
    setupCanvasAsRenderTexture(canvas) {
        const context = canvas.getContext("2d");
        canvas.context = context;
        canvas.context.scissor = undefined;
        // Save base state so we can restore the defaults later.
        context.save();
    }
    copyRenderTexture(renderTexture, nativeTexture, options) {
        throw new Error("Copy render texture not implemented");
    }
}
//# sourceMappingURL=C2dRenderer.js.map